import { render, staticRenderFns } from "./SmartReviewSettings.vue?vue&type=template&id=492cb8a3"
import script from "./SmartReviewSettings.vue?vue&type=script&lang=js"
export * from "./SmartReviewSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports